import { Switch } from "@mui/material";
import React from "react";
import { TaskTypeClassNoTitle } from "ui/Scripts/source/models/enums";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";

interface IFormDesignerComponentPropertiesNoTitleInRowProps {
    taskTypeCol?: ITaskTypeCol;
    onChange?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

const getChecked = (classes: string) => {
    return classes.includes(" " + TaskTypeClassNoTitle.No + " ");
};

export const FormDesignerComponentPropertiesNoTitleInRow = (
    props: IFormDesignerComponentPropertiesNoTitleInRowProps
) => {
    //NOTE: class name may be used in other style class as prefix or suffix => need to use padding (problem: sText <=> sTextArea)
    const classes = " " + (props.taskTypeCol?.class ?? "") + " ";

    const handleChange = (e: any, aChecked: boolean) => {
        props.onChange([{
            field: props.taskTypeCol?.field,
            name: "class",
            value: classes
                .replace(" " + TaskTypeClassNoTitle.No + " ", " ").trim() +
                (aChecked ? " " + TaskTypeClassNoTitle.No : "")
        }]);
    };

    const checked = getChecked(classes);

    return (
        <Switch
            checked={checked}
            onChange={handleChange}
        />
    );
};
